import { all } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';

import { isDateInFuture, isFullySpecifiedDate } from 'app/forms/validations/common';
import isFirstName from 'app/forms/validations/isFirstName';
import isLogin from 'app/forms/validations/isLogin';
import isSellerOrProposalNo from 'app/forms/validations/isSellerOrProposalNo';
import isSurname from 'app/forms/validations/isSurname';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';
import { radioOptionsIds } from 'features/other/resolverSettings/constants';

export const TASK_FORWARDING_FORM_NAME = 'taskForwarding-form';

const { superior, subordinate, agency, region, sellerIn, login } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	deadlineDate: 'deadlineDate',
	radio: 'radio',
	superior,
	subordinate,
	agency,
	region,
	login,
	sellerIn,
	userFirstName: 'userFirstName',
	userSurname: 'userSurname',
};

export default () => ({
	[FIELDS.deadlineDate]: {
		deepPath: [FIELDS.deadlineDate],
		validations: [isFullySpecifiedDate(), isDateInFuture()],
	},
	[FIELDS.radio]: {
		deepPath: [FIELDS.radio],
		validations: [isRequired()],
	},
	[FIELDS.superior]: {
		deepPath: [FIELDS.superior],
		validations: [
			isRequired({
				when: ({ formData }) => formData?.radio === radioOptionsIds.superior,
			}),
		],
	},
	[FIELDS.subordinate]: {
		deepPath: [FIELDS.subordinate],
		validations: [
			isRequired({
				when: ({ formData }) => formData?.radio === radioOptionsIds.subordinate,
			}),
		],
	},
	[FIELDS.agency]: {
		deepPath: [FIELDS.agency],
		validations: [isRequired({ when: ({ formData }) => formData?.radio === radioOptionsIds.agency })],
	},
	[FIELDS.region]: {
		deepPath: [FIELDS.region],
		validations: [isRequired({ when: ({ formData }) => formData?.radio === radioOptionsIds.agency })],
	},
	[FIELDS.login]: {
		deepPath: [FIELDS.login],
		validations: [
			isRequired({
				when: ({ formData }) =>
					formData?.radio === radioOptionsIds.users &&
					all(isNilOrEmpty)([formData?.sellerIn, formData?.userSurname]),
			}),
			isLogin(),
		],
	},
	[FIELDS.sellerIn]: {
		deepPath: [FIELDS.sellerIn],
		validations: [
			isRequired({
				when: ({ formData }) =>
					formData?.radio === radioOptionsIds.users &&
					all(isNilOrEmpty)([formData?.login, formData?.userSurname]),
			}),
			isSellerOrProposalNo(),
		],
	},
	[FIELDS.userFirstName]: {
		deepPath: [FIELDS.userFirstName],
		validations: [isFirstName()],
	},
	[FIELDS.userSurname]: {
		deepPath: [FIELDS.userSurname],
		validations: [
			isRequired({
				when: ({ formData }) =>
					formData?.radio === radioOptionsIds.users &&
					all(isNilOrEmpty)([formData?.login, formData?.sellerIn]),
			}),
			isSurname(),
		],
	},
});
